export default __webpack_public_path__ + "static/media/base-background.a0630c73.jpg";